<template>
  <div class="second_layout">
    <keep-alive>
      缓存
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: 'ChildrenView',
  data() {
    return {}
  },
  created() {
    // console.log('layout555555555555555555');
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.second_layout {
  width: 100%;
  height: 100%;
}
</style>
